import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02e73f8d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=02e73f8d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e73f8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02e73f8d')) {
      api.createRecord('02e73f8d', component.options)
    } else {
      api.reload('02e73f8d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=02e73f8d&scoped=true", function () {
      api.rerender('02e73f8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/chat/index.vue"
export default component.exports